import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
export default function ClaimerPreviewCompanyInfo(_ref) {
  let {
    aifReportData
  } = _ref;
  const {
    aif_model
  } = aifReportData;
  return /*#__PURE__*/React.createElement(Card, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-dark text-white"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "mb-0"
  }, "Company Information")), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement("strong", null, "UTR:"), " ", aif_model.company.utr), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement("strong", null, "PAYE Reference:"), " ", aif_model.company.paye_reference), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement("strong", null, "VAT Reference:"), " ", aif_model.company.vat_reference), /*#__PURE__*/React.createElement(Col, {
    md: 3
  }, /*#__PURE__*/React.createElement("strong", null, "SIC Code:"), " ", aif_model.company.sic_code))));
}